import React, { useState } from "react";
import { motion } from "framer-motion";
import { transition1 } from "../transitions";
import { useNavigate } from "react-router-dom";

const Hero = () => {
  const navigate = useNavigate();

  return (
    <>
      <motion.section
        initial={{ opacity: 0, y: "100%" }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: "100%" }}
        transition={transition1}
        className="section hidden lg:block xl:block lg:mb-10 2xl:mb-40 h-full"
        style={{ position: "relative" }}
      >
        <div className="relative flex top-20 items-center">
          <video
            className="left-0 w-full h-full object-cover"
            autoPlay
            muted
            loop
            playsInline
          >
            <source src="/videos/trailer.mp4" type="video/mp4" />
          </video>
          <div
            className="absolute top-10 p-4 z-20"
            style={{ left: "50%", transform: "translateX(-50%)" }}
          >
            {/* <h1 className='h1 drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)] text-white text-center'>
    WeCollective
  </h1> */}
          </div>

          <div
            className="absolute bottom-2 lg:bottom-20 p-4 z-20"
            style={{ left: "50%", transform: "translateX(-50%)" }}
          >
            <div
              onClick={() => navigate("/open-calls")}
              className="hover:cursor-pointer border px-2 py-1 hover:text-black hover:bg-white hover:border-black border-gray-400 lg:px-10 lg:py-4 lg:text-2xl bg-black drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)] text-white text-center"
            >
              Open Calls
            </div>
          </div>
        </div>
      </motion.section>
      <motion.section
        initial={{ opacity: 0, y: "100%" }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: "100%" }}
        transition={transition1}
        className="lg:hidden w-full flex justify-center items-center py-4 mt-10"
      >
        <div className="relative w-full">
          <video
            className="w-full h-auto object-contain"
            autoPlay
            muted
            loop
            playsInline
          >
            <source src="/videos/trailer.mp4" type="video/mp4" />
          </video>

          <div className="absolute top-4 left-1/2 transform -translate-x-1/2 z-20">
            {/* Optional Title or Content */}
          </div>

          <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 z-20">
            <div
              onClick={() => navigate("/open-calls")}
              className="cursor-pointer border px-4 py-2 text-sm hover:text-black hover:bg-white hover:border-black border-gray-400 bg-black text-white text-center"
            >
              Open Calls
            </div>
          </div>
        </div>
      </motion.section>
    </>
  );
};

export default Hero;
